export default __webpack_public_path__ + "dee4eb6cbd6a20b359e59d62fda3b711.svg";